import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-shield-check-line',
    title: '正版资源保障',
    description: '平台所有漫画均获得正版授权，同人作品严格遵守版权规定，为创作者和读者建立健康生态。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步阅读',
    description: '支持Web、iOS、Android多平台使用，账号互通，阅读进度云端自动同步，随时随地继续阅读。',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '离线下载功能',
    description: '高级会员每月100话离线下载额度，WiFi环境提前下载，无网络也能畅享漫画阅读乐趣。',
  },
  {
    icon: 'ri-award-line',
    title: '会员专属权益',
    description: '高级会员享无限阅读、超清画质、去广告、抢先阅读等多项特权，年度订阅仅需¥128。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择 JM Comic？
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            海量资源、优质体验、安全保障——JM Comic 为每一位漫画爱好者打造极致的阅读平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-100/70 rounded-xl p-6 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-primary-50 text-primary-600 rounded-xl mb-4">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 mb-2 text-base">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/article/jm-comic-vip-benefits"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            了解更多会员权益
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}